<!-- 平台期评估问卷 -->
<template>
  <div class="q4">
    <div class="result">
      <img
        class="bg"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e8c98e00099ee5d7823b2d86ed2dba44.png"
        alt=""
      />
      <div v-if="info">
        <div class="c-item container">
          <div class="user-info">
            <div class="avatar" v-if="info.head_img">
              <img class="avatar-image" :src="info.head_img" alt="" />
            </div>
            <div class="nickname">{{
              info.truename || info.nickname || ''
            }}</div>
          </div>
          <img class="icon" :src="iconData[info.result_alia]" alt="" />
          <div class="desc">{{ info.result_title }}</div>
          <div class="desc1" v-html="info.result_content"></div>
          <div class="more" @click="bindMore">更多问卷</div>
        </div>
        <div class="c-item course-container">
          <div class="course-box">
            <div class="course-content">
              <img
                class="dot"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f29d97a36d51bdf43b4b05737d02c77c.png"
                alt=""
              />
              <div class="c-desc">{{ info.recommend_title }}</div>
            </div>
          </div>
          <div class="camp-list">
            <div
              class="camp-item"
              v-for="(item, index) in info.recommend_content"
              :key="index"
            >
              <div class="camp-title">{{ item.title }}</div>
              <div class="camp-text">{{ item.content }}</div>
            </div>
          </div>
          <div class="my-course" @click="bindMyCourse">
            <img
              class="icon"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0cec1237411857d7ea5bbf350efd73e2.png"
              alt=""
            />
            <div class="text">我的课程</div>
            <div class="iconfont icon-you"></div>
          </div>
        </div>
        <img
          class="logo"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getShareUrl } from '../../common.js'
import appApi from '@/common/app-common.js'
export default {
  data() {
    return {
      info: null,
      iconData: {
        platform_syn:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/99c68f0b06187a5fba56e53e04399579.png',
        platform_no:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9f4c02d726ab769c3c32e83418a0b827.png',
        platform_again:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f9a60447e73a04f61dfabae143678a19.png'
      }
    }
  },
  created() {
    this.getResult()
  },
  methods: {
    bindMore() {
      this.$router.push('/common-questions/home')
    },
    getResult() {
      let params = {
        que_user_id: this.$route.query.que_id,
        admin_uid: this.$route.query.admin_uid,
        que_id: this.$route.query.que_type
      }
      this.$http
        .getBaseAppWithHeader('que/QueBase/getQueResult', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.info = res.data
            this.$emit('copyUrl', getShareUrl(this.info.que_id))
          } else {
            this.$toast(res.msg)
          }
        })
    },
    bindMyCourse() {
      appApi.jumpMiniProgram({
        appId: 'gh_3da9370ac840',
        path: 'page/home/index'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-item {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.q4 {
  overflow: scroll;
  background-color: #f7f7f7;
  min-height: 100vh;

  .result {
    position: relative;
    padding: 56px 16px 30px;
    box-sizing: border-box;
    min-height: 60vh;
    background-image: linear-gradient(
      180deg,
      rgba(169, 157, 251, 1) 0px,
      rgba(169, 157, 251, 0) 350px
    );

    .bg {
      position: absolute;
      right: 30px;
      top: 10px;
      width: 121px;
      height: 109px;
      object-fit: contain;
    }
  }

  .container {
    background: #ffffff;
    box-shadow: 0px 5px 9px 0px rgba(58, 55, 82, 0.03);
    border-radius: 16px;
    border: 2px solid #ffffff;
    padding: 0px 22px 26px;

    .user-info {
      width: 100%;
      margin-top: -26px;
      text-align: center;
      padding-bottom: 12px;
      border-bottom: 1px dashed rgba(58, 55, 82, 0.16);

      .avatar {
        margin: 0 auto;
        width: 54px;
        height: 54px;
        border: 2.5px solid #fff;
        box-sizing: border-box;
        border-radius: 50%;
        overflow: hidden;
        margin-bottom: 6px;
        .avatar-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .nickname {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #27243c;
        line-height: 22px;
      }
    }

    .icon {
      width: 112px;
      height: 112px;
      margin: 10px auto;
      object-fit: contain;
    }

    .desc {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #27243c;
      line-height: 22px;
      text-align: center;
      margin-bottom: 5px;
    }

    .desc1 {
      text-align: center;
      font-size: 11px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(39, 36, 60, 0.45);
      line-height: 20px;
      margin-bottom: 56px;

      .purple {
        color: rgba(159, 145, 254, 1);
      }
    }

    .more {
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      text-align: center;
      border: 1px solid rgba(82, 68, 133, 0.3);
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #524485;
    }
  }
}

.course-container {
  padding-top: 34px;

  .course-box {
    position: relative;
    margin-bottom: 16px;
    width: 100%;

    .course-content {
      padding: 16px;
      box-sizing: border-box;
      border-radius: 6px;
      background: linear-gradient(
        180deg,
        rgb(240, 238, 254) 0%,
        rgb(242, 240, 255) 100%
      );
      position: relative;
      z-index: 1;

      .dot {
        width: 40px;
        height: 40px;
        position: absolute;
        left: 14px;
        top: 0;
        transform: translate(0%, -50%);
      }

      .c-flex {
        display: flex;
        align-items: flex-end;
        margin-bottom: 2px;

        .c-flex-left {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          font-size: 11px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #73689d;
          line-height: 20px;
        }

        .c-avatar {
          width: 40px;
          height: 40px;
          object-fit: cover;
          margin-left: 20px;
        }
      }

      .c-desc {
        font-size: 15px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #73689d;
        line-height: 24px;
      }
    }
  }

  .course-box::after {
    content: '';
    position: absolute;
    z-index: 0;
    width: 0px;
    height: 0px;
    right: 50px;
    bottom: -10px;
    border-left: 20px solid rgb(242, 240, 255);
    border-bottom: 10px solid transparent;
    border-top: 10px solid transparent;
  }

  .camp-list {
    .camp-item {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px dashed rgba(58, 55, 82, 0.12);
      margin-bottom: 9px;

      .camp-title {
        position: relative;
        z-index: 1;
        padding-left: 8px;
        border-radius: 4px 3px 3px 4px;
        width: 90px;
        box-sizing: border-box;
        height: 20px;
        font-size: 11px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 20px;
        background: linear-gradient(
          180deg,
          #cdc4ff 0%,
          #9f91fe 80%,
          rgba(185, 174, 255, 1) 100%
        );
        margin-right: 10px;
      }

      .camp-title::after {
        content: '';
        position: absolute;
        z-index: -1;
        width: 14px;
        height: 14px;
        background: linear-gradient(
          135deg,
          #cdc4ff 0%,
          #9f91fe 80%,
          rgba(185, 174, 255, 1) 100%
        );
        right: 0;
        top: 50%;
        border-radius: 0px 4px 0px 0px;
        transform: translate(45%, -50%) rotate(45deg);
        transform-origin: center;
      }

      .camp-text {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 11px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #27243c;
        line-height: 20px;
      }
    }

    .camp-item:last-child {
      border-bottom: none;
      margin-bottom: 0px;
    }
  }

  .my-course {
    margin-top: 12px;
    height: 42px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e1dede;
    display: flex;
    align-items: center;
    padding: 0px 16px;

    .text {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #27243c;
      line-height: 18px;
      margin-right: 10px;
    }

    .icon {
      width: 26px;
      height: 26px;
      object-fit: contain;
      margin-right: 10px;
    }

    .iconfont {
      font-size: 20px;
      color: rgba(39, 36, 60, 0.5);
    }
  }

  .desc {
    text-align: center;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(39, 36, 60, 0.36);
    line-height: 18px;
  }
}

.share {
  font-size: 24px;
}

.logo {
  height: 12px;
  margin: 20px auto 0px;
}
</style>
